export default __webpack_public_path__ + "static/media/USA_Commitment.e7ba79da.pdf";